<template>
  <div>
    <pregunta-form
      :is-add-new-user-sidebar-active.sync="isAddNewSidebarActive"
      :form-type="formType"
      :data-edit="dataEdit"
      :order="order"
      :id-encuesta="idEncuesta"
      :list-question.sync="listQuestionsName"
      @refetch-data="refetchData"
      @error-data="showError"
    />
    <bloque-form
      :is-add-new-user-sidebar-active.sync="isAddNewSidebarActiveBloque"
      :form-type="formTypeBloque"
      :data-edit="dataEdit"
      @refetch-data="refetchData"
      @error-data="showError"
    />
    <b-card
      no-body
      class="mb-0"
    >
      <b-card-header>
        <b-card-title>
          <b-button
            v-b-tooltip.hover.top="back"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            class="mr-2"
            :to="{ name: 'app-encuesta-encuesta'}"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              class="mr-50 fa-green"
            />
          </b-button>
        </b-card-title>
        <b-card-title class="text-primary">
          <b-button
            variant="primary"
            @click="openBloqueForm('new')"
          >
            Gestión de Bloques
          </b-button>
          <b-button
            variant="primary"
            style="margin-left:7px"
            @click="openForm('new')"
          >
            Nueva Pregunta
          </b-button>
        </b-card-title>
      </b-card-header>
      <b-card-body>
        <section class="container_mobile">
          <div class="box_up">
            <span class="camara" />
            <span class="circles" />
            <span class="audio_up" />
          </div>
          <!--<div
            class="screen"
          > -->
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="screen"
          >
            <validation-observer
              #default="{ handleSubmit }"
              ref="refFormObserver"
            >
              <div
                v-if="isBusy"
                class="text-center text-primary my-2"
              >
                <b-spinner
                  variant="primary"
                  class="align-middle"
                />
                <strong class="ml-1">Cargando...</strong>
              </div>
              <div
                v-if="questions.length<=0 && !isBusy"
                class="text-center text-primary my-2"
              >
                <strong class="ml-1">Datos no encontrados</strong>
              </div>
              <form
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
              >
                <draggable
                  :list="questions"
                  :disabled="!enabled"
                  class="list-group"
                  ghost-class="moving-card"
                  @start="dragging = true"
                  @change="changePosition"
                > <!-- :animation="200" :move="checkMove" @end="onEnd" -->
                  <div
                    v-for="(ctrlData, index) in questions"
                    :key="index"
                  >
                    <div
                      v-if="ctrlData.bloqueActual!=='NINGUNO'"
                      class="col-sm-12"
                      style="font-weight: bold; font-size: 14px; font-family: cursive; margin:2%"
                    >
                      {{ ctrlData.bloqueActual }}
                    </div>
                    <div class="row dropdownGridMove">
                      <div class="col-sm-12">
                        <!-- INPUT-->
                        <span class="d-block">
                          <span>
                            {{ index + 1 }}.- {{ ctrlData.enunciado }}
                          </span>
                          <span
                            v-if="ctrlData.requerido"
                            style="color:#ea5455; font-weight:bold"
                          >
                            (*)
                          </span>
                        </span>
                        <div
                          v-if="ctrlData.tipoPregunta.questionType !== 'select_one list_name' && ctrlData.tipoPregunta.questionType !== 'select_multiple list_name' && ctrlData.tipoPregunta.questionType !== 'note'"
                        >
                          <div
                            v-if="ctrlData.tipoPregunta.questionType === 'text' && ctrlData.apariencia.appearance === 'minimal'"
                          >
                            <b-form-input
                              :id="formData[ctrlData.name]"
                              :ref="`est_${ctrlData.name}`"
                              v-model="formData[ctrlData.index]"
                              :name="formData[ctrlData.name]"
                              :placeholder="ctrlData.bindFieldPlaceholder"
                              class="w-100"
                            />
                          </div>
                          <div
                            v-if="ctrlData.tipoPregunta.questionType === 'text' && ctrlData.apariencia.appearance === 'multiline'"
                          >
                            <b-form-textarea
                              :id="formData[ctrlData.name]"
                              :ref="`est_${ctrlData.name}`"
                              v-model="formData[ctrlData.index]"
                              :name="formData[ctrlData.name]"
                              :placeholder="ctrlData.bindFieldPlaceholder"
                              class="w-100"
                            />
                          </div>
                          <div
                            v-if="ctrlData.tipoPregunta.questionType === 'integer' || ctrlData.tipoPregunta.questionType === 'decimal'"
                          >
                            <b-form-input
                              :ref="`est_${ctrlData.name}`"
                              v-model="formData.pk[ctrlData.index]"
                              :placeholder="ctrlData.bindFieldPlaceholder"
                              class="w-100"
                              :formatter="calculateNote()"
                              @keypress="validBindType($event, ctrlData.name, 2, ctrlData.bindType)"
                            />
                          </div>
                          <div
                            v-if="ctrlData.tipoPregunta.questionType === 'image'"
                            style="text-align:center"
                          >
                            <b-img
                              :src="imgPhoneCamara"
                              width="100px"
                            />
                            <b-img
                              :src="imgPhoneCarpeta"
                              width="60px; margin-left:-10px"
                            />
                          </div>
                          <div
                            v-if="ctrlData.tipoPregunta.questionType === 'date'"
                            style="text-align:center"
                          >
                            <b-form-datepicker
                              :ref="`est_${ctrlData.name}`"
                              v-model="formData.pk[ctrlData.index]"
                              class="mb-1"
                              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                              locale="es"
                              placeholder="Selecccione fecha"
                            />
                          </div>
                          <!-- @keypress="validBindType($event, ctrlData.name, 2, ctrlData.bindType)" -->
                        </div>
                        <div
                          v-if="ctrlData.tipoPregunta.questionType === 'select_one list_name' || ctrlData.tipoPregunta.questionType === 'select_multiple list_name' || ctrlData.tipoPregunta.questionType === 'ubigeo' || ctrlData.tipoPregunta.questionType === 'condicional-dependiente'"
                        >
                          <b-form-select
                            type="select"
                            class="custom-select"
                          >
                            <option value="">
                              SELECCIONE::
                            </option>
                          </b-form-select>
                        </div>
                        <div
                          v-if="ctrlData.tipoPregunta.questionType === 'note'"
                        >
                          <input
                            v-show="false"
                            v-model="formData.pk[ctrlData.index]"
                          >
                          <span>
                            {{ formData.pk[ctrlData.index] }}
                          </span>
                        </div>
                        <div
                          class="dropdownGrid"
                        >
                          <b-dropdown
                            variant="link"
                            no-caret
                            class="chart-dropdown"
                            toggle-class="p-0"
                            left
                          > <!-- left -->
                            <template #button-content>
                              <feather-icon
                                icon="MoreVerticalIcon"
                                size="18"
                                class="text-body cursor-pointer"
                              /><!-- style="background-color: yellow;text-align: center !important;position: absolute;top: 16px;" -->
                            </template>
                            <b-dropdown-item
                              @click.stop="openEdit(ctrlData)"
                            >
                              Editar
                            </b-dropdown-item>
                            <b-dropdown-item
                              @click.stop="getDelete(ctrlData)"
                            >
                              Eliminar
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                        <!-- <div
                          class="dropdownGridMove"
                        >
                          <feather-icon
                            icon="MoreVerticalIcon"
                            class="draggable-task-handle d-inline"
                          />
                        </div> -->
                      </div>
                    </div>
                  </div>
                </draggable>
              </form>
              <!-- <control
                v-for="(ques, name) in questions"
                :key="name"
                :control-data="ques"
                @refetch-data="openEdit"
              /> -->
            </validation-observer>
          </vue-perfect-scrollbar>
          <div class="buttons_down">
            <span class="btn_home" />
          </div>
        </section>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>

import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import {
  BCard, BCardBody, BCardTitle, BImg, BButton, BCardHeader, VBTooltip, BDropdown, BDropdownItem, BFormInput, BFormSelect, BFormTextarea, BFormDatepicker, BSpinner,
} from 'bootstrap-vue'
import { _ } from 'vue-underscore'
import { ValidationObserver } from 'vee-validate'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import { ref } from '@vue/composition-api'
import { useNotify } from '@/helpers/toast'
import { validDecimals, onlyNumbers, onlyLetters } from '@/helpers'
import formValidation from '@core/comp-functions/forms/form-validation'
import PreguntaForm from './PreguntaForm.vue'
import BloqueForm from './BloqueForm.vue'
import imgPhone1 from '../../../../assets/images/encuesta/imgPhone1.png'
import imgPhone2 from '../../../../assets/images/encuesta/carpetaPhone.png'
// import Control from './Components/Control.vue'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BCardBody,
    BButton,
    BCardHeader,
    BCardTitle,
    // Control,
    PreguntaForm,
    VuePerfectScrollbar,
    BFormSelect,
    BFormTextarea,
    BFormDatepicker,
    /* CONTROL */
    BDropdown,
    BDropdownItem,
    BFormInput,
    ValidationObserver,
    draggable,
    BImg,
    BloqueForm,
    BSpinner,
  },
  data() {
    return {
      perPage: 10,
      back: 'Atrás',
      imgPhoneCamara: imgPhone1,
      imgPhoneCarpeta: imgPhone2,
      fieldsPreguntaGrupoOpcion: [
        { key: 'grupoOpcion.descripcion', label: 'Grupo' },
        { key: 'valor', label: 'Valor' },
        { key: 'label', label: 'Label' },
        { key: 'requeridoDescripcion', label: 'Requiere Descripción' },
        { key: 'orden', label: 'orden' },
      ],
      statusOptions: [
        'Downloaded',
        'Draft',
        'Paid',
        'Partial Payment',
        'Past Due',
      ],
      fields: [{ key: 'bloque.nombre', label: 'Bloque' }, { key: 'tipoPregunta', label: 'Tipo Pregunta' }, 'enunciado', { key: 'orden', label: 'Orden' }, { key: 'action', label: 'acciones' }],
      items: [],
      status: [{
        1: 'Current', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
    }
  },
  setup(props, context) {
    const { notify } = useNotify(context)
    const questions = ref([])
    const isBusyControl = ref(false)
    const isBusy = ref(false)
    const enabled = ref(true)
    const order = ref(1)
    const listQuestionsName = ref([])
    const questionsName = ref([])
    const isAddNewSidebarActive = ref(false)
    const formType = ref('')
    const dataEdit = ref({})
    const idEncuesta = ref(0)
    const bloqueDefaultList = ref(0)
    const ordenMove = ref('')

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
      suppressScrollX: true,
      useBothWheelAxes: true,
      swipeEasing: true,
    }
    const formData = ref({
      pk: [],
    })
    const ctrForm1 = ref('') // INPUT NORMAL
    const ctrForm2 = ref('') // INPUT DAT,DATETIME
    const ctrForm3 = ref('') // DIVS,SPAMN
    const formTypeBloque = ref('')
    const isAddNewSidebarActiveBloque = ref(false)
    const formDataTotal = ref({
      pk: [],
    })
    const blankData = {
      idPregunta: '',
    }
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
    }

    const {
      refFormObserver,
    } = formValidation(resetData)

    const listarRegistros = async () => {
      isBusy.value = true
      await store
        .dispatch('gsencuesta/PREGUNTA_FIND_BY_ENCUESTA', { id: router.currentRoute.params.id })
        .then(response => {
          questions.value = []
          questionsName.value = []
          let bloqueActual = ''
          let auxBloque = '' // bloque lista row actual
          response.forEach((dat, index) => {
            if (auxBloque !== dat.bloque.nombre) {
              bloqueActual = dat.bloque.nombre // pintamos el phone
            } else {
              bloqueActual = ''
            }
            auxBloque = dat.bloque.nombre
            if (index === 0) {
              bloqueActual = dat.bloque.nombre
              auxBloque = bloqueActual
            }
            questions.value.push({
              index,
              apariencia: dat.apariencia,
              bindFieldPlaceholder: dat.bindFieldPlaceholder,
              bindType: dat.bindType,
              bloque: dat.bloque,
              bloqueActual,
              calculation: dat.calculation,
              choice_filter: dat.choice_filter,
              defecto: dat.defecto,
              enunciado: dat.enunciado,
              idPregunta: dat.idPregunta,
              encuesta: dat.encuesta,
              name: dat.name,
              orden: dat.orden,
              readonly: dat.readonly,
              bindFieldLength: dat.bindFieldLength,
              preguntaGrupoOpcion: dat.preguntaGrupoOpcion,
              requerido: dat.requerido,
              requerido_msj: dat.requerido_msj,
              tipoPregunta: dat.tipoPregunta,
              questionType: dat.tipoPregunta.questionType,
              formulaCondicion: dat.formulaCondicion,
              condicionalDependiente: dat.condicionalDependiente,
            })
            order.value = dat.orden
            questionsName.value.push({
              idPregunta: dat.idPregunta,
              name: dat.name,
              enunciado: dat.enunciado,
              questionType: dat.tipoPregunta.questionType,
              formulaCondicion: dat.formulaCondicion,
            })
            /* if (dat.tipoPregunta.questionType === 'integer' || dat.tipoPregunta.questionType === 'decimal' || dat.tipoPregunta.questionType === 'note') {
              questionsName.value.push({
                idPregunta: dat.idPregunta,
                name: dat.name,
                questionType: dat.tipoPregunta.questionType,
              })
            } */
          })
          isBusy.value = false
        })
        .catch(() => {
          isBusy.value = false
        })
    }
    listarRegistros()
    const refetchData = response => {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      notify('Operación Extitosa', message, 'success')
      listarRegistros()
    }
    /* const formulaOperators = operator => {
      const operators = ['+', '-', '*', '/', 'div', '=', '!=', '<', '<=', '>', '>=', 'or', 'and', 'mod']
      const result = _.contains(operators, operator)
      return result
    } */
    const calculateNote = () => {
      const formulateList = _.where(questions.value, { questionType: 'note' })
      let result = ''
      if (formulateList.length > 0) {
        formulateList.forEach(dat1 => {
          let total = dat1.calculation
          questions.value.forEach(dat2 => {
            const v1 = _.isUndefined(formData.value.pk[dat2.index]) ? 0 : formData.value.pk[dat2.index]
            total = total.replace(dat2.name, v1)
            result = total
          })
          const tot = eval(result) // eslint-disable-line no-eval
          formData.value.pk[dat1.index] = tot
        })
      }
    }
    const getDelete = data => {
      Vue.swal({
        title: '¿Está seguro de eliminar este registro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('gsencuesta/PREGUNTA_DELETE', {
              id: data.idPregunta,
            })
            .then(response => {
              listarRegistros()
              notify('Operación Extitosa', 'Ha Eliminado correctamente el registro', 'success')
              return response
            })
            .catch(error => {
              notify('Ha ocurrido un error', error.response.data.errorMessage, 'danger')
            })
        }
      })
    }
    const openEdit = data => {
      formType.value = 'edit'
      isAddNewSidebarActive.value = true
      dataEdit.value = data
      listQuestionsName.value = questionsName.value
      idEncuesta.value = Number(router.currentRoute.params.id)
    }
    const openForm = type => {
      listQuestionsName.value = questionsName.value
      formType.value = type
      isAddNewSidebarActive.value = true
      idEncuesta.value = Number(router.currentRoute.params.id)
    }
    const openBloqueForm = type => {
      formTypeBloque.value = type
      isAddNewSidebarActiveBloque.value = true
    }
    /* const checkMove = e => {
      let om = 0
      const { futureIndex } = e.draggedContext
      om = futureIndex
      if (futureIndex > 0) {
        om = futureIndex - 1
      }
    } */
    const changePosition = e => {
      const listIdPreg = []
      let ord = e.moved.newIndex - 1
      if (ord < 0) {
        ord = 1
      }
      // console.log(questions.value[ord].bloque.idBloque)
      questions.value[e.moved.newIndex].bloqueActual = '' // limpia la pregunt movible
      questions.value[e.moved.newIndex].bloque.idBloque = questions.value[ord].bloque.idBloque
      questions.value.forEach(dat => { // AQUI YA ESTÁ ORDENADO LAS PREGUNTAS
        const row = {
          idPregunta: dat.idPregunta,
          bloqueActual: dat.bloqueActual,
          bloque: {
            idBloque: dat.bloque.idBloque,
          },
        }
        listIdPreg.push(row)
      })
      // console.log(listIdPreg)
      const service = 'gsencuesta/PREGUNTA_UPDATE_ORDEN'
      store.dispatch(service, listIdPreg)
        .then(() => {
          notify('Operación Extitosa', 'Datos actualizados correctamente', 'success')
          listarRegistros()
        })
        .catch(error => {
          notify('Ha ocurrido un error', error.response.data.message, 'danger')
        })
    }
    /* const changePosition = e => {
      console.log(questions.value)
      const { newIndex, element } = e.moved
      element.orden = newIndex
      if (element.preguntaGrupoOpcion === null) {
        element.preguntaGrupoOpcion = [
          {
            idPreguntaGrupoOpcion: 0,
            grupoOpcion: {
              idGrupoOpcion: 0,
            },
          },
        ]
      }
      const service = 'gsencuesta/PREGUNTA_UPDATE'
      console.log(element)
      store.dispatch(service, element)
        .then(() => {
          notify('Operación Extitosa', 'Datos actualizados correctamente', 'success')
        })
        .catch(error => {
          notify('Ha ocurrido un error', error.response.data.message, 'danger')
        })
    } */
    /* const onEnd = () => {
      console.log('hola')
    } */
    return {
      questions,
      isAddNewSidebarActive,
      formType,
      dataEdit,
      idEncuesta,
      questionsName,
      getDelete,
      openEdit,
      openForm,
      perfectScrollbarSettings,
      refetchData,
      isBusyControl,
      ctrForm1,
      ctrForm2,
      ctrForm3,
      calculateNote,
      formDataTotal,
      formData,
      resetData,
      refFormObserver,
      order,
      listQuestionsName,
      enabled,
      bloqueDefaultList,
      // checkMove,
      changePosition,
      openBloqueForm,
      isAddNewSidebarActiveBloque,
      formTypeBloque,
      ordenMove,
      isBusy,
      // opCombinaditas,
      // loadQuiz,
    }
  },
  methods: {
    /* calcularEval() {
      console.log(eval('35*75/100')) // eslint-disable-line no-eval
    }, */
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    refetchDataOpcion(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
    },
    validBindType($event, control, decimals, bindType) {
      switch (bindType) {
        case 'int': onlyNumbers($event); break
        case 'decimal': validDecimals($event, control, decimals, this.$refs); break
        case 'string': onlyLetters($event); break
        default: this.$bvToast.toast('Advertencia', { title: 'Es necesario ingresar tipo de dato correcto en la validación', variant: 'warning', solid: true }); break
      }
    },
    onlyNumbers,
    validDecimals,
    onlyLetters,
  },
}
</script>
<style lang="scss" scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.container_mobile{
  width: 300px;
  height: 570px;
  border-radius: 40px;
  background-color: rgb(36, 36, 36);
  margin: 40px auto;
}
.box_up{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  position:relative;
}
.camara{
  display: block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: rgb(107, 107, 107);
  margin-left: 40px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.camara::before{
  content: '';
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background-color: rgb(119, 148, 150);
  position: absolute;
}
.circles{
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgb(107, 107, 107);
  margin-left: 10px;
  position: relative;
}
.circles:before{
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgb(107, 107, 107);
  left: 11px;
  border-radius: 50%;
}
.audio_up{
  display: block;
  width: 60px;
  height: 7px;
  border-radius: 20px;
  background-color: rgb(107, 107, 107);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.screen{
  width: 280px;
  height: 450px;
  background: #ffffff;
  border-radius: 5px;
  margin: 0 auto;
  padding: 10px;
}
.buttons_down{
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn_home{
  width: 70px;
  height: 25px;
  border: 2px solid rgb(151, 151, 151);
  border-radius: 40px;
}
.dropdownGrid{
  background-color: #F8F8F8!important;
  position: absolute;
  border-radius: 5%!important;
  top: 0px !important; /* 22 */
  width: 2px !important;
  left: 1px !important;
}
.moving-card {
  @apply opacity-50 bg-gray-100 border border-blue-500;
}
.dropdownGridMove {
  cursor: move;
}
</style>
